// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const DEBUG = false;

export default class MenuHandler extends WebComponent {

	static defaultProps = {
		hoverClass:             'hover',
		hiddenClass:            'hidden',
		menuLinkSelector:      '.megamenu__category-link',
		menuItemsSelector:      '.megamenu__category-item.with-children',
		submenuWrapperSelector: '.megamenu',
		submenuItemsSelector:   '.megamenu__subcategory-item',
	};

	constructor(props) {
		super(props);
		this.isTouchDevice = !!(
			('ontouchstart' in window) ||
			(window.DocumentTouch && document instanceof DocumentTouch)
		);
	}

	didMount() {
		clog(`didMount`);
		this.handleMouseEnter = this.handleMouseEnter.bind(this);
		this.handleMouseLeave = this.handleMouseLeave.bind(this);
		this.handleTouch = this.handleTouch.bind(this);


		if (this.isTouchDevice) {
			this.handleTouchNavigation();
		} else {
			this.menuItemsWithSubNav = this.element.querySelectorAll(this.props.menuItemsSelector);
			[ ...this.menuItemsWithSubNav ].forEach((menuItem) => {
				const hasMegamenu = !!(menuItem.querySelector(this.props.submenuWrapperSelector)) || false;
				if ( hasMegamenu && menuItem instanceof HTMLElement ) {
					menuItem.addEventListener('mouseenter', this.handleMouseEnter);
					menuItem.addEventListener('mouseleave', this.handleMouseLeave);
				}
			});
		}
	}

	willUnMount() {
		clog(`willUnMount`);
		[ ...this.menuItemsWithSubNav ].forEach((menuItem) => {
			const hasMegamenu = !!(menuItem.querySelector(this.props.submenuWrapperSelector)) || false;
			if ( hasMegamenu && menuItem instanceof HTMLElement ) {
				menuItem.removeEventListener('mouseenter', this.handleMouseEnter);
				menuItem.removeEventListener('mouseleave', this.handleMouseLeave);
			}
		});
		this.menuItemsWithSubNav = null;
		clearTimeout(this.menuTimeout);
		this.menuTimeout = null;
	}

	handleMouseEnter(event) {
		clearTimeout(this.menuTimeout);

		event.target.style.zIndex = 20;
		event.target.classList.add(this.props.hoverClass);

		const hoverElements = [ ...this.element.querySelectorAll('.hover') ];
		hoverElements.forEach((hoverElement) => {
			if ( hoverElement !== event.target ) {
				hoverElement.style.zIndex = 10;
				setTimeout(() => {
					hoverElement.classList.remove(this.props.hoverClass);
				}, 400);
			}
		});
	}

	handleMouseLeave(event) {
		event.target.style.zIndex = 10;
		this.menuTimeout = setTimeout(() => {
			event.target.classList.remove(this.props.hoverClass);
		}, 600);
	}

	handleTouch(event) {
		// debugger;
		const touchedItem = event.target;
		this._hideSubnavigation();
		if (touchedItem.nextElementSibling) {
			event.preventDefault();
			touchedItem.nextElementSibling.classList.remove(this.props.hiddenClass);
		}
	}

	handleTouchNavigation() {
		clog(`has touch`);
		this._findSubnavigation();
		this._bindSubnavigation();
		this._hideSubnavigation();
	}

	_findSubnavigation() {
		this.subnavigLinks = this.element.querySelectorAll(this.props.menuLinkSelector);
	}

	_hideSubnavigation() {
		[ ...this.subnavigLinks ].forEach((menuItem) => {
			if (menuItem.nextElementSibling) menuItem.nextElementSibling.classList.add(this.props.hiddenClass);
		});
	}

	_bindSubnavigation() {
		[ ...this.subnavigLinks ].forEach((menuItem) => {
			menuItem.addEventListener('click', this.handleTouch );
		});
	}

}


// simple logger
function clog(...args: any): void {
	if ( window.console && DEBUG ) {
		/* eslint-disable no-alert, no-console */
		console.group('Debug of MenuHandler');
		Object.values(args).forEach(value => console.log(value));
		console.groupEnd();
		/* eslint-enable no-alert, no-console */
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/MenuHandler.js